var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title)?_c('h5',{staticClass:"mx-1 my-0"},[(_vm.icon)?_c('i',{staticClass:"mr-2",class:_vm.icon}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.title)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }